// (A) 중립 Dropdown API — antd 미접촉. (B) PlainDropdownMenu(Radix Popover + 커스텀 리스트)에 위임.
// menu.items 는 OmwMenuItem[] 로 정규화(antd MenuProps 흡수). popupRender 로 임의 콘텐츠도 지원.
import type { CSSProperties, ReactNode } from 'react'
import type { OmwMenuClickInfo, OmwMenuItem } from './OmwMenu'
import { PlainDropdownMenu } from '../_impl/PlainDropdownMenu'

// 열린 om-dropdown(click/contextMenu/none 전부)을 레지스트리로 직접 닫는다. blurHandler 가
// DOM 트리거 `.click()` 으로 닫지 못하는 contextMenu 까지 닫기 위함.
export { closeAllOpenDropdowns } from '../_impl/PlainDropdownMenu'

export type OmwDropdownTrigger = 'click' | 'hover' | 'contextMenu'

export type OmwDropdownPlacement =
  | 'top'
  | 'topLeft'
  | 'topRight'
  | 'bottom'
  | 'bottomLeft'
  | 'bottomRight'

/** selectable 메뉴의 선택/해제 콜백 정보(antd Menu onSelect/onDeselect 중립화). */
export interface OmwMenuSelectInfo {
  key: string
  selectedKeys: string[]
}

/** Dropdown 의 메뉴 설정(antd MenuProps 중립화). */
export interface OmwDropdownMenuConfig {
  items: OmwMenuItem[]
  onClick?: (info: OmwMenuClickInfo) => void
  selectedKeys?: string[]
  selectable?: boolean
  /** 다중 선택 허용. */
  multiple?: boolean
  /** 선택 콜백. */
  onSelect?: (info: OmwMenuSelectInfo) => void
  /** 선택 해제 콜백. */
  onDeselect?: (info: OmwMenuSelectInfo) => void
  /**
   * 키보드 활성 항목 하이라이트.
   * antd MenuProps 는 타입상 activeKey 를 omit 하나 rc-menu 백엔드가 런타임 지원한다.
   */
  activeKey?: string | null
  /** 메뉴 루트 tabIndex. */
  tabIndex?: number
}

/** 팝업 위치 미세 조정(antd align 중립화, 실측: offset 만 사용). */
export interface OmwDropdownAlign {
  offset?: [number, number]
}

export interface OmwDropdownMenuProps {
  /** items 기반 메뉴. popupRender 와 택일. */
  menu?: OmwDropdownMenuConfig
  /** menu 대신(또는 menu 를 감싸는) 임의 팝업 콘텐츠 렌더. antd 기본 menu 노드를 인자로 받는다. */
  popupRender?: (menu?: ReactNode) => ReactNode
  /** 실측: ['click'] · [] (트리거 없음). */
  trigger?: OmwDropdownTrigger[]
  open?: boolean
  onOpenChange?: (open: boolean) => void
  placement?: OmwDropdownPlacement
  disabled?: boolean
  destroyOnHidden?: boolean
  overlayClassName?: string
  overlayStyle?: CSSProperties
  /** 팝업 위치 offset 조정. */
  align?: OmwDropdownAlign
  getPopupContainer?: (trigger: HTMLElement) => HTMLElement
  className?: string
  /** 트리거 엘리먼트. */
  children?: ReactNode
}

export function OmwDropdownMenu(props: OmwDropdownMenuProps) {
  return <PlainDropdownMenu {...props} />
}
